import { getRoleRegionsByRoleId } from '@/services/api'
export default {
  namespace: 'user',

  state: {
    username: null,
    avatar: 'https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png',
    userGroup: null,
    permissions: [], // 权限信息
    roleId: null,
    allRegions: [],
  },

  effects: {
    *queryRoleRegions({ payload }, { call, put }) {
      const res = yield call(getRoleRegionsByRoleId,payload)
      yield put({
        type: 'saveRegions',
        payload: res,
      })
    },
  },

  reducers: {
    changeUser(state, { payload }) {
      if (!payload.developerId) {
        payload.developerId = null
      }
      /**
       * 全局保存 developerId 变量，所有的接口中都带上改变量
       */
      window.developerId = payload.developerId
      return { ...state, ...payload }
    },
    savePermissions(state, { payload }) {
      return { ...state, permissions: payload }
    },
    saveRegions(state, { payload }) {
      return { ...state, allRegions: payload }
    },
  },
}
